// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCompareFlyOutStyles } from "@conklin/Overrides/Components/ProductCompareFlyOut";
import { color, createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

const arrowStyle = {
    css: css`
        position: absolute;
        top: 50%;
        background: ${color("common.ui6", 0.75)};
        height: 78px;
        width: 34px;
        transform: translate(0, -50%);
        & > ${IconWrapper} {
            color: ${color("common.white")};
        }

        & > ${IconWrapper} {
            transition: all ${getProp("theme.transition.duration.regular", "300")}ms ease-in-out;
            &,
            > svg {
                width: auto;
                height: 22px;
            }
        }
        &:not(:disabled):hover {
            & > ${IconWrapper} {
                color: ${color("common.ui10")};
            }
        }
        z-index: 10;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        outline: none !important;

        &:focus {
            box-shadow: none;
        }
    `,
};

productCompareFlyOutStyles.carouselDrawer = {
    ...productCompareFlyOutStyles.carouselDrawer,
    cssOverrides: {
        ...productCompareFlyOutStyles.carouselDrawer?.cssOverrides,

        drawerTitle: css`
            background: ${color("common.white")};
            color: ${color("text")};
            padding-top: 5px;
            padding-bottom: 10px;
        `,
        drawerBody: css`
            background-color: ${color("common.white")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 125px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
};

productCompareFlyOutStyles.productRemoveLink = {
    ...createLinkIconStyles(X, "default", "left", false, {
        color: "text",
        css: css`
            position: absolute;
            top: 0;
            right: -27px;
            &&& ${IconWrapper} {
                color: ${color("common.ui4")};
            }
            &&&:hover ${IconWrapper} {
                color: ${color("common.ui10")};
            }
        `,
    }),
};

productCompareFlyOutStyles.headerGridContainer = {
    ...productCompareFlyOutStyles?.headerGridContainer,
    offsetCss: css`
        ${xScreen("lte", "md")} {
            padding: 0 12px;
        }
    `,
};

productCompareFlyOutStyles.carousel = {
    mainContainer: {
        offsetCss: css`
            padding: 0 5px;
            position: relative;

            ${xScreen("lte", "md")} {
                padding: 0 12px;
            }
        `,
        gap: 0,
        css: css`
            margin: 0 auto;
            width: 100%;
            max-width: 100%;
        `,
    },
    titleText: {
        css: css`
            display: none;
        `,
    },
    nextArrowButton: arrowStyle,
    prevArrowButton: arrowStyle,
};

productCompareFlyOutStyles.condensed = {
    productPartNumbersStyles: {
        erpNumberValueText: {
            css: css`
                max-width: 13ch;
            `,
        },
        manufacturerItemValueText: {
            css: css`
                max-width: 13ch;
            `,
        },
        customerNameValueText: {
            css: css`
                max-width: 13ch;
            `,
        },
        container: {
            css: css`
                margin-bottom: 0;
            `,
        },
    },
};
productCompareFlyOutStyles.carouselContainer = {
    gap: 0,
    css: css`
        width: 100%;
        margin: 0 auto;
    `,
};
